import Component from 'vue-class-component';
import { Action, Getter } from 'vuex-class';
import { Vue, Watch } from 'vue-property-decorator';
import { APP_IS_IDLE, RESET_STORE } from '@/types/store.types';

@Component({})
export default class IdleModalComponent extends Vue {

  @Action(RESET_STORE) public resetStore;

  @Getter(APP_IS_IDLE) public appIsIdle!: boolean;

  /*idle*/
  private showIdleModal: boolean = false;
  private intervalId: any = 0;
  private timeoutId: any = 0;
  private timerMs: number = 1000 * 60 * 5; // 2 minutes
  private idleSecondCounter: number = this.timerMs / 1000;
  // private idleSecondCounter: number = 2;
  private firstTime: boolean = true;

  @Watch('appIsIdle')
  public onAppIsIdleChanged(newVal: any, oldVal: any) {
    if (this.firstTime) {
      this.firstTime = false;
      return;
    }
    if (!this.showIdleModal) {
      // this.idleSecondCounter = this.timerMs / 1000;
      this.idleSecondCounter = 5 * 60;
      if (newVal) {
        this.showIdleModal = true;
        this.startTimer();
      } else {
        clearInterval(this.intervalId);
        clearTimeout(this.timeoutId);
      }
    }
  }

  public startTimer() {
    clearInterval(this.intervalId);
    this.intervalId = setInterval(this.countDown, 1000);

    clearTimeout(this.timeoutId);
    this.timeoutId = setTimeout(() => {
      clearInterval(this.intervalId);
      this.logoutFromApp();
    }, this.timerMs);
  }

  public countDown() {
    this.idleSecondCounter -= 1;
  }

  public logoutFromApp() {
    this.resetStore();
    this.$router.push({ name: 'login' });
  }

  /*computed*/
  get seconds() {
    const s: any = ((this.idleSecondCounter % 60) + '');
    return s.padStart(2, '0');
  }

  get minutes(): number {
    const s: any = (Math.trunc(this.idleSecondCounter / 60) + '');
    return s.padStart(2, '0');
  }

  public cancelIdle() {
    this.showIdleModal = false;
    clearInterval(this.intervalId);
    clearTimeout(this.timeoutId);
    this.logoutFromApp();
  }

  public confirmIdle() {
    this.showIdleModal = false;
    clearInterval(this.intervalId);
    clearTimeout(this.timeoutId);
  }
}
